<template>
  <div class="clearfix main_center" v-loading.fullscreen.lock="loading">

    <div class="right-content clearfix">


      <el-card class="box-card" style="position: relative">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <div class="processStatus">
          <img :src="processedImg" v-if="historyid==0">
        </div>
        <el-form   label-width="152px" class="form">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="项目编号：" >{{ form.projectCode }} </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目名称：">{{ form.projectName }}    </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="标段名称：" >{{ form.bidName }}   </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="招标人名称：" >{{ form.tenderName }}  </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="招标代理机构：" >{{ form.tenderAgentName }} </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>


      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>出证申请信息</span>
        </div>
        <el-form   label-width="152px" class="form">
          <el-row :gutter="15">
          <el-col :span="12">
              <el-form-item label="申请单位：" >{{ questName }} </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请时间：" >{{ questTime }} </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-form-item label="申请出证原因:" style="width:90%;">
            <el-input type="textarea" v-model="questReason"  disabled></el-input>
          </el-form-item>
          </el-row>
        </el-form>
      </el-card>


      <el-card class="box-card" >
        <div slot="header" class="clearfix">
          <span>进场交易见证书</span>
        </div>
        <div v-if="filePath != '' && filePath != undefined " >
          <iframe  :src="pdfViewer + filePath " frameborder="0" width="100%" height="700" @contextmenu.prevent=""></iframe>
        </div>
        <div v-else :style="{'height':'500px'}">
          <emptyInfo :emptyMsg="'暂无见证数据'" ></emptyInfo>
        </div>

      </el-card>



    </div>


    <div class="left-content">
      <div class="left-navbar">
        <el-button type="primary" plain size="small" style="margin-right:10px;" @click="downloadPdf()"  >下载</el-button>
        <el-button @click="back()" size="small" style="margin-left:0;">返回</el-button>
      </div>
    </div>


  </div>
</template>

<script>
  import $ from 'jquery';
  import emptyInfo from '@/components/empty-info';
  import {mapState} from "vuex";
  import {tabsCloseCurrentHandle} from '@/utils/routeTab';

  export default {
  components: {
    emptyInfo
  },
  data() {
    return {
      id: "",
      pdfViewer:'/pdf/web/viewer.html?file=',
      processedImg:require('@/assets/images/status_witness.png'),
      form: {
        id: '',
        filePath:'',
        projectCode: '',
        projectName:'',
        bidName:'',
        tenderName:'',
        tenderAgentName:'',
        projectHandleTime:'',
        tenderNoticeTime:'',
        tenderFileTime:'',
        evalprofExtractTime:'',
        bidopenAddress:'',
        bidopenTime:'',
        evalTime:'',
        evalAddress:'',
        candidateTime:'',
        resultNoticeTime:'',
        noficationTime:'',
        winerName:'',
        winBidprice:'',
        winWorkItem:'',
        winProjectMainer:'',
      },

      loading: false,
      user: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      questName:'',  //申请单位
      questReason: '',  //申请出证原因
      questTime:'', //申请时间

      dataId: 0,
      formId: '',
      groupList: [],
      formInfo: {},
      tableData: [],


    }
  },

  filters: {},
  created() {
    this.pdfViewer = this.$http.adornUrl(this.pdfViewer);
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
    filePath:function () {
      return this.form.filePath;
    },
  },

  activated() {

    // $route.query.id为首页通过 url跳转 带过来的参数
    this.id = (this.$route.query && this.$route.query.id) || (this.$route.params && this.$route.params.id) || '';
    this.getDetailById();

  },

  methods: {
    //列表查看进来根据id查询详情
    getDetailById() {

      if (this.id) {

        // 查询基本信息及流程id
        this.$http.get('/cateQuestBase/get?id=' + this.id).then(res => {
          if (res.data.code === '1') {
            const data = res.data.data;
            this.form = {...data};
            if (data.cateoutQuest!=undefined){
              this.questReason=data.cateoutQuest.questReason;
              this.questName=data.cateoutQuest.questName || this.stateData.displayName;
              this.questTime=data.cateoutQuest.questTime;
              this.historyid=data.cateoutQuest.historyid;
            }
            this.form.filePath = (data.attachments && data.attachments[0] && data.attachments[0].filePath ) || '';
          }
        })

      } else {
        this.$router.push({
          name: 'home'
        })
      }

    },


    // 返回
    back() {
      tabsCloseCurrentHandle();
      this.$router.push({
        name: 'cateout_quest_list',
        query:{
          id:this.id
        }
      });
    },

    //下载该pdf
    downloadPdf() {
      if (this.id) {
        this.$http({
          method:'get',
          url:`/attachment/downloadFile?businessId=${this.id}&fileType=1`,
        }).then(res => {

                if(res.data.code==='1'){
                  var a = document.createElement('a');
                  a.download = '进场交易见证书.pdf';
                  a.target="_Blank";
                  a.href = res.data.data;
                  $("body").append(a);
                  a.click();
                  $(a).remove();

                }else{

                  this.$message({
                    type:'error',
                    message:res.data.msg
                  })

                }



            })
      }
    },







  },
  deactivated() {
  },


}
</script>

<style lang="less" scope>

  .processStatus{
    position: absolute;
    right:20px;
    top: 20px;
    img{
      opacity: 0.5;
    }
  }

.bidFileList {
  width: 100%;
  border: 1px solid #ebeef5;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;

  th {
    border: 1px solid #ebeef5;
    height: 40px;
  }

  td {
    border: 1px solid #ebeef5;
    height: 30px;
  }
}


</style>